import $http from "../axios";

const state = {
  blockedUsers: []
};

const getters = {
  blockedUsers(state) {
    return state.blockedUsers;
  }
};

const actions = {
  getBlockedUsers({ commit }) {
    return new Promise((resolve, reject) => {
      $http
        .get("get-blocked-users")
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_BLOCKED_USERS", res.data.payload);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  blockUser(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("block-user", data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  unblockUser({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("unblock-user", data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("REMOVE_BLOCKED_USER", data.userId);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_BLOCKED_USERS(state, payload) {
    state.blockedUsers = payload.blockedUsers;
  },

  REMOVE_BLOCKED_USER(state, userId) {
    const index = state.blockedUsers.findIndex(b => {
      return b.user._id === userId;
    });
    if (index > -1) {
      state.blockedUsers.splice(index, 1);
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
